<template>
  <main>
    <Header :loginSource="2"></Header>

    <section v-if="courses.length" class="merchant_container">
      <div class="merchant_wrapper">
        <div class="order_title">课程列表</div>
        <hr>

        <div v-for="(item, index) in courses" :key="index" class="merchant_block">
          <div class="merchant_content">

            <img class="storefront_image" :src="item.course.coverPic" @click="playCourse(item)">
            <div class="merchant_desc">
              <div class="merchant_desc">
                <div style="cursor: pointer;" @click="playCourse(item)">课程名称：{{item.name}}</div>
                <div>学习进度</div>
                <div class="block" v-if="item.process < 1.0">
                  <el-progress :text-inside="true" :stroke-width="20" :percentage="ceil(item.process * 100)"></el-progress>
                </div>
                <div class="block" v-else>
                  <el-progress :text-inside="true" :stroke-width="20" :percentage="ceil(item.process * 100)" status="success"></el-progress>
                </div>
                <br>
                <div>
                  <el-button type="primary" icon="el-icon-caret-right" @click="playCourse(item)">继续学习</el-button>
                </div>
              </div>
            </div>
          </div>
          <hr>
        </div>

      </div>
    </section>
    <div class="no_data_tip" style="margin-top: 50px; margin-bottom: 700px;" v-else>
      当前无学习记录，请前往<el-link type="primary" @click="gotoIndex()">首页</el-link>选择课程学习。
    </div>
    <Footer></Footer>
  </main>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import {mapState, mapGetters} from 'vuex'
import {
  reqFindCoursePlayInfo
} from '@/api'

export default {
  name: 'CoursePlayInfo',
  components: {Header, Footer},

  data() {
    return {
      courses: [], // 课程列表
    }
  },

  async mounted () {
    if (!this.isLogin) {
      await this.$router.push('/')
      return
    }

    const loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    const result = await reqFindCoursePlayInfo()
    if (result.code === 0) {
      this.courses = result.data
    } else {
      await this.$alert("系统异常，请稍后再试", '错误', {
        confirmButtonText: '确定',
        callback: action => {
        }
      })
    }
    loading.close()
  },

  methods: {
    playCourse (item) {

      this.$router.push({
        path: '/playCourse',
        query: {no: item.no, videoNo: item.lastVideoNo}
      }).catch(err=>{})

    },

    gotoIndex () {
      this.$router.push({
        path: '/index'
      }).catch(err=>{})
    },

    ceil (n) {
      return Math.ceil(n)
    }

  },

  computed: {
    // ...mapState(['phone']),
    ...mapGetters(['isLogin']),
  }
}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .merchant_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    /*border: 1px solid black;*/
  }

  .merchant_wrapper {
    width: 1000px;
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    position: relative;
  }

  .order_title {
    /*line-height: 40px;*/
    margin-top: 20px;
    font-size: 16px;
    font-weight: 500;
  }

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .merchant_content {
    display: flex;
  }

  .storefront_image {
    width: 250px;
    height: 190px;
    border-radius: 6px;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid;
  }

  .merchant_desc {
    display: flex;
    flex-direction: column;
  }

  .merchant_desc div:first-child {
    font-size: 16px;
    color: #000;
    font-weight: bold;
  }

  .merchant_desc div {
    line-height: 30px;
    font-size: 14px;
    color: #999;
  }

  .price_wrapper {
    display: flex;
  }

  .price_wrapper div:first-child {
    font-size: 24px;
    color: #FF6666;
    margin-right: 14px;
  }

  .no_data_tip {
    display: flex;
    width: 100%;
    justify-content: center;
    font-size: 14px;
    color: #666;
    line-height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/CoursePlayInfo/CoursePlayInfo.vue